export enum GatewayType {
  Unknown,
  Data,
  Trading,
  Combined
}
